import { useState } from 'react';
import { Box, Button, Flex, Heading, IconButton } from '@chakra-ui/react';
import { RiAddFill, RiFilter2Line, RiFlowChart } from 'react-icons/ri';
import { useNavigate } from 'react-router';
import { useAuthContext } from '@contexts/auth';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';
import useGetSalesFunnelsList from '@hooks/useGetSalesFunnelsList';
import usePaginationParams from '@hooks/usePaginationParams';

import UpsertDialog from './components/UpsertDialog';
import FunnelCard from './components/FunnelCard';
import Filters from './components/Filters';
import SelectedFiltersList from './components/SelectedFiltersList';

const SalesFunnel = () => {
  const navigate = useNavigate();
  const { checkIfHasRole } = useAuthContext();

  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const {
    getSalesFunnels,
    salesFunnels,
    loading,
    totalPages,
  } = useGetSalesFunnelsList();

  usePaginationParams({ onParamsChange: getSalesFunnels });

  const getCurrentComponent = () => {
    if (loading && salesFunnels.length === 0) return <Loading />;

    if (!loading && salesFunnels.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhum funil de venda encontrado.
        </Box>
      );
    }

    return (
      <Box opacity={loading ? 0.5 : 1} transition="opacity 0.15s ease">
        <PaginationRouterContainer
          total={totalPages}
        >
          {salesFunnels.map((saleFunnel) => (
            <FunnelCard
              key={saleFunnel.id}
              saleFunnel={saleFunnel}
              refetch={() => getSalesFunnels({})}
            />
          ))}
        </PaginationRouterContainer>
      </Box>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={2}>
        <Flex alignItems="center">
          <Heading>Funil de vendas</Heading>
          <IconButton
            variant="ghost"
            color="argos.fg"
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <RiFilter2Line size={24} />
          </IconButton>
        </Flex>
        <Flex gap={2}>
          {checkIfHasRole('CAN_MANAGE_SALESFUNNELS') && (
            <Button size="sm" variant="outline" onClick={() => navigate('/painel/funil-de-vendas/editor')}>
              <RiFlowChart /> Editor visual
            </Button>
          )}
          {checkIfHasRole('CAN_MANAGE_SALESFUNNELS') && (
            <Button size="sm" onClick={() => setShowAddDialog(true)}>
              <RiAddFill /> Novo
            </Button>
          )}
        </Flex>
      </Flex>

      {showFilters ? (
        <Filters onClose={() => setShowFilters(false)} />
      ) : (
        <SelectedFiltersList />
      )}

      {getCurrentComponent()}

      {showAddDialog && (
        <UpsertDialog
          handleClose={() => setShowAddDialog(false)}
          afterSubmit={() => getSalesFunnels({})}
        />
      )}
    </Box>
  );
};

export default SalesFunnel;
